import { Injectable } from '@angular/core';
import { RunType } from '@office-start/first-run-types';

import { CapabilitiesService } from '../shared/shared-context/capabilities.service';

@Injectable({
    providedIn: 'root'
})
export class FirstRunReactStateService {
    private completedFirstRun: boolean = true;
    private completedSecondRun: boolean = true;
    private runType: RunType = RunType.Disabled;
    private readonly statePromise: Promise<Array<boolean>>;
    private readonly secondRunEnabled: boolean;

    constructor(
        private readonly capabilitiesService: CapabilitiesService
    ) {
        this.secondRunEnabled = this.capabilitiesService.capabilities.secondRunSREConsumerEnabled;

        this.statePromise = this.fetchState();
        this.statePromise.then(([completedFirstRun, completedSecondRun]) => {
            this.completedFirstRun = completedFirstRun;
            this.completedSecondRun = completedSecondRun;
            this.determineRunType();
        });
    }

    public async getRunType(): Promise<RunType> {
        await this.statePromise;
        return this.runType;
    }

    private determineRunType (): void {
        if (!this.completedFirstRun) {
            this.runType = RunType.FirstRun;
        } else if (this.completedFirstRun && this.secondRunEnabled && !this.completedSecondRun) {
            this.runType = RunType.SecondRun;
        } else {
            this.runType = RunType.Disabled;
        }
    }

    private fetchState() {
        const firstRunStateServicePromise = import('@office-start/first-run-state-service');

        return firstRunStateServicePromise.then(mod => {
            const firstRunPromise = mod.fetchFirstRunState().then(firstRunState => firstRunState.CompletedFirstRun);
            const secondRunPromise = mod.fetchSecondRunState().then(secondRunState => secondRunState.CompletedFirstRun);

            return Promise.all([firstRunPromise, secondRunPromise]);
        });
    }
}
